import { X } from "lucide-react";

interface CancelPillProps {
  onCancel: () => void;
}

const CancelPill = ({ onCancel }: CancelPillProps) => {
  return (
    <button
      onClick={onCancel}
      className="absolute top-4 right-4 z-20 flex items-center gap-2 px-4 py-2
                 rounded-full text-sm font-medium shadow-lg border backdrop-blur-sm
                 transition-colors duration-200
                 hover:bg-red-50 hover:border-red-200 hover:text-red-600
                 focus-visible:ring-2 focus-visible:ring-[var(--sage-400)] focus-visible:ring-offset-2"
      style={{
        background: "rgba(255, 255, 255, 0.95)",
        borderColor: "var(--brand-border)",
        color: "var(--brand-muted)",
        animation:
          "cancel-pill-in 0.5s cubic-bezier(0.22, 1, 0.36, 1) forwards, cancel-pill-pulse 2s ease-in-out 1s infinite",
      }}
      aria-label="Cancel preview generation"
    >
      <span
        className="w-5 h-5 rounded-full flex items-center justify-center transition-colors"
        style={{ background: "var(--sage-50)" }}
      >
        <X className="w-3 h-3" />
      </span>
      Cancel
    </button>
  );
};

export default CancelPill;
